import React, { useState, useEffect } from "react";
// import "./style.css";
import { useParams } from "react-router-dom";
import Pageloader from "../../../components/loader";
import {Typography, Button, Descriptions, Space, Image, Avatar, message} from "antd";
import { RollbackOutlined, UserOutlined } from "@ant-design/icons";
import ModalBtn from "../../../components/modal/universialModal/modalButton";
import ModalBody from "../../../components/modal/universialModal/modalBody";
import AssignZone from "./assignDetail/assignZone";
import { useNavigate } from "react-router-dom";

import * as actionPage from "../../../redux/actions/pickerPakerPage.actions";
import * as zoneActions from "../../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";
import { userhasPermissionHelper } from "../../../utils/Helpers";

const { Title, Text } = Typography;
const pageName = "Picker Packer";
const pageLink = "pickerpacker";

const PickerPackerDetail = (props) => {
  const params = useParams();
  const { postid } = params;
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(null);
  const [postDataZone, setPostDataZone] = useState(null);

  useEffect(() => {
    postLists();
  }, []);

  const postLists = async () => {
    try {
      await props.actionPage.detailAction(postid)  
    } catch {}
  };

  useEffect(() => {
    postListsZones()
  }, []);

  const postListsZones = async() => {
    await props.zoneActions.getZoneListAction();
  }

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item) => {
        zoneData.push({value: item?.id, label: item?.zoneName})
      });
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  // Modal Start **********************
  const modalCancel = () => {
    setModalOpen(null)
  }

  const modalonAction = (value=null, type=null, formBody=null) => {
    setModalOpen(()=>({
      modal: true,
      value: value,
      type: type,
      formBody: formBody,
    }))
  }

  const onCreateAction = async (values, info) => {
    if (info?.type === 'visible_zone') {
      const newData = {
        ...values,
        pickerPackerId: postid,
      }
      try {
        await props.actionPage.assignZoneAction(newData).then((res)=>{
          {message.success(res.data.message)}
        });
        postLists()
        modalCancel()
      } catch {}
    }
  }
  // Modal End **********************

  const checkZones = (value) => {
    const zoneData = [];
    if(value && value?.zone && Array.isArray(value?.zone)){
      value && value?.zone.map((item)=>{
        item?.id !== null && zoneData.push(item?.id)
      })
    }
    return zoneData
  }

  const viewZones = (value) => {
    const zoneData = [];
    if(value && value?.zone && Array.isArray(value?.zone)){
      value && value?.zone.map((item)=>{
        item?.id !== null && zoneData.push(<Text>{item?.zoneName}</Text>)
      })
    }
    return zoneData
  }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{pageName} Detail</Title>
        <div>
          <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
        </div>
      </div>
      <div className="p-content">
        {props.pageLoading ? <Pageloader /> : <>
          <div className="page-content-header">
            <div style={{maxWidth: "48%"}}>
              <Space direction="vertical" style={{width: "100%"}}>
                {props?.pageData?.profileImage ? (
                  <Image alt="Profile Image" src={props?.pageData?.profileImage}/>
                ) : (<Avatar shape="square" size={75} icon={<UserOutlined />} />)}
                
                <Descriptions>
                  <Descriptions.Item label="P/P ID" span={3}>{props?.pageData?.display_id || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Name" span={3}>{props?.pageData?.fullName || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Email" span={3}>{props?.pageData?.email || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Phone Number" span={3}>{props?.pageData?.phoneNumber || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Status" span={3}>{props?.pageData?.status || "-"}</Descriptions.Item>
                  <Descriptions.Item label="CNIC" span={3}>{props?.pageData?.cnic || "-"}</Descriptions.Item>
                  <Descriptions.Item label="City" span={3}>{props?.pageData?.city || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Current OTP" span={3}>{props?.pageData?.current_otp || "-"}</Descriptions.Item>
                </Descriptions>
              </Space>
            </div>
            { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_PICKER_PACKER) &&
              <div style={{maxWidth: "48%"}}>
                <ModalBtn type={'btn'} onAction={modalonAction} formBody={<AssignZone zoneOption={postDataZone} value={props?.pageData}/>} value={{...props?.pageData, zoneIds: checkZones(props?.pageData)}} title="visible_zone" />              
                <div className="krflex krbadge">{viewZones(props?.pageData)}</div>
              </div>
            }
          </div>
          { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_PICKER_PACKER) &&
            (modalOpen && <ModalBody modalOpen={modalOpen} Loading={props.pageLoading} modalCancel={modalCancel} onCreateAction={onCreateAction}/>)
          }
        </>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
    pageData: state.PickerPakerPageReducer?.initialDetail,
    pageLoading: state.PickerPakerPageReducer?.initialLoading,
    zoneData: state.ZoneReducer.zoneData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PickerPackerDetail);